import FlowPolicyCollection from './FlowPolicyCollection';
import FlowPolicyTemplateModel from './FlowPolicyTemplateModel';

class FlowPolicyTemplateCollection extends FlowPolicyCollection {
  get url() {
    return '/api/ui/alerting/policy-templates/flow';
  }

  get model() {
    return FlowPolicyTemplateModel;
  }
}

export default FlowPolicyTemplateCollection;
